import React from "react";
import { BaseModal } from "./BaseModal";
import { useStore } from "../../stores/store";
import { ModalKeys } from "../../interfaces/config";

export default function DisclaimerModal() {
  const { isActive, deactivateTool, config } = useStore();

  return (
    <BaseModal active={isActive(ModalKeys.DISCLAIMER)} title="DISCLAIMER">
      <div className="p-3 font-helvetica text-sm h-[30vh] md:h-auto overflow-y-auto">
        {config?.disclaimerMessage ? (
          <p dangerouslySetInnerHTML={{ __html: config?.disclaimerMessage }} className="py-1"></p>
        ) : (
          <>
            <p className="py-1">
              Information in this web application may contain inaccuracies or
              typographical errors. Information may be changed or updated
              without notice and is provided 'as-is' without warranty of any
              kind, either expressed or implied, including (without limitation)
              any implied warranties of merchantability or fitness for a
              particular purpose. In no event will McHenry County be liable to
              you or to any third party for any direct, indirect, incidental,
              consequential, special, or exemplary damages or lost profit
              resulting from any use or misuse of this information. Information
              has been reproduced from original sources and should not be used
              in place of a survey or legal documents.
            </p>
            <p className="py-1">
              Data within this application is compiled from various departments.
              Please review the Sources of Information document in this
              application to determine the contact of who maintains each dataset
              or please direct questions or issues by email to:{" "}
              <a
                className="link text-blue-500 hover:text-blue-700"
                href="mailto:gis@mchenrycountyil.gov"
                target="_blank"
              >
                gis@mchenrycountyil.gov
              </a>
            </p>
            <p className="py-1">
              PLEASE NOTE: Tax data within this application may not reflect the
              most current information. Please review any official tax documents
              or contact the Supervisor of Assessments for the most accurate
              information. <br />Email:{" "}
              <a
                className="link text-blue-500 hover:text-blue-700"
                href="mailto:assessments@mchenrycountyil.gov"
                target="_blank"
              >
                assessments@mchenrycountyil.gov
              </a>
            </p>
            For maximum performance, the lowest level recommended browser for this application is Internet Explorer 9.0. The application is also compatible with Firefox, Chrome and Safari.
          </>
        )}
        {config?.attentionText && (
          <>
            <p className="text-red-500">ATTENTION:</p>
            <p className="text-red-500 py-1">{config?.attentionText}</p>
          </>
        )}
        {/* <p className="py-1">
          For maximum performance, the lowest level recommended browser for this
          application is Internet Explorer 9.0. The application is also
          compatible with Firefox, Chrome and Safari.
        </p> */}
      </div>
      <div className="bg-[#f5f5f5] border-t border-[#ddd] w-full text-right p-1">
        <button
          onClick={() => {
            deactivateTool(ModalKeys.DISCLAIMER);
          }}
          className="btn-athena btn-sm mr-1"
        >
          OK
        </button>
      </div>
    </BaseModal>
  );
}
